import { routerPostCall } from '../../axios';

const getNewAccessToken = (state, params) => {
  const url = `/auth/token/new`;
  return routerPostCall(state, url, params);
};
export default { getNewAccessToken };
